import styled from 'styled-components';
import BoxContainer from 'containers/BoxContainer';

export const Wrapper = styled(BoxContainer)`
  box-sizing: border-box;
  padding: 20px;
`;

export const PickedWrapper = styled.div`
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  height: 272px;
  width: 100%;
`;

export const ControlWrapper = styled.div`
  position: absolute;
  z-index: 99;
  top: 12px;
  right: 12px;
`;

export const Preview = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

export const UploadWrapper = styled.div`
  box-sizing: border-box;
  padding: 24px;
  border: 2px dashed ${({theme}) => theme.variables.borderColor};
  border-radius: 5px;
`;
